import zipcodes from '../data/zipcodes.json'

export default {
   getMunicipality (zip) {
      const item = zipcodes.find(x => x.zip === zip)

      if (item == null) {
         return ''
      } else {
         return item.municipality
      }
   }
}
